import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {withTranslation} from 'react-i18next';
import {inject, observer} from 'mobx-react';
import * as R from 'ramda';

import NavDropdown from 'react-bootstrap/NavDropdown';
import Nav from 'react-bootstrap/Nav';
import Spinner from 'react-bootstrap/Spinner';

import {
  NEWS_ADMIN_ROUTE,
  CHANGE_PASSWORD_ROUTE,
  CONTESTS_ADMIN_ROUTE,
  USERS_ADMIN_ROUTE,
  SIGNIN_II_ROUTE,
  passRouteParams,
  ADMIN_ROLE,
  COLLECTIONS_ROUTE,
  ROOT_ROUTE,
  MEDALS
} from 'Internal';

import './DefaultHeader.scss';

class UserNav extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      userId : null,
    };
  }

  componentDidMount() {
    this.getCurr();
  }

  getCurr() {
    const {
      stores: {
        authStore,
      },
    } = this.props;

    this.setState({loading: true});

    authStore.getCurrent()
      .then((resp) => this.setState({userId: resp.data.id}))
      .catch(() => () => this.setState({userId: null}))
      .finally(() => this.setState({loading: false}));
  }

  render() {
    const {
      t,
      history,
      stores: {
        authStore,
      },
    } = this.props;


    const {
      loading,
      userId
    } = this.state;

    if (loading) {
      return  <Spinner animation="grow" variant="danger" size="sm" className="mt-2"/>;
    }

    return (
      !authStore.authData.username
          ? <Nav.Link to={SIGNIN_II_ROUTE} as={Link}>{t('Sign in')}</Nav.Link>
          : <>
            <NavDropdown
              id="user-nav-dropdown"
              title={authStore.authData.username}
              alignRight
            >
              <NavDropdown.Item
                onClick={() => history.push(CONTESTS_ADMIN_ROUTE)}
              >
                {t('Competitions')}
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => history.push(NEWS_ADMIN_ROUTE)}
        >
          {t('News')}
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => history.push(COLLECTIONS_ROUTE)}
        >
          {t('Directories')}
        </NavDropdown.Item>
        {(authStore.authData.roleName) === ADMIN_ROLE && (<NavDropdown.Item
          onClick={() => history.push(MEDALS)}
        >
          {t('PurposeOfMedals')}
        </NavDropdown.Item>)}
        {(authStore.authData.roleName) === ADMIN_ROLE && (<NavDropdown.Item
          onClick={() => history.push(USERS_ADMIN_ROUTE)}
        >
          {t('Administrators')}
        </NavDropdown.Item>)}
        <NavDropdown.Divider/>
        <NavDropdown.Item
          onClick={() => history.push(passRouteParams(CHANGE_PASSWORD_ROUTE, {id: userId}))}
        >
          {t('ChangePassword')}
        </NavDropdown.Item>
        <NavDropdown.Item
          onClick={() => this.setState(
            {
              userId: null,
            },
            () => {
              authStore.signOut();
              history.push(ROOT_ROUTE);
            }
          )}
        >
          {t('Exit')}
        </NavDropdown.Item>
      </NavDropdown>
      </>
    );
  }
}

function applyContext(WrappedComponent) {
  const injectContext = R.pipe(
    observer,
    inject('stores'),
    withRouter,
    withTranslation(['header'])
  );
  return injectContext(WrappedComponent);
}

export default applyContext(UserNav);
